import { lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { AppProvider } from 'context'
import NotFound from 'components/NotFound'
import Login from 'pages/login'

import MedicationDetails from 'pages/providers/clinics/clinc-detail/clinic-treatments/treatment-details/treatment-medications/medication-details'
import SetPassword from 'pages/login/set-password'
import Cart from 'pages/providers/pharmacy/cart'
import Medications from 'pages/providers/pharmacy/order-items/medications'
import PharmacyMedications from 'pages/providers/pharmacy/order-items/medications/pharmacy-medications'
import PharmacyTreatments from 'pages/providers/pharmacy/order-items/medications/pharmacy-treatments'
import { OrdersList } from 'components/orders/order-list'
import PharmacyTreatmentDetails from 'pages/providers/pharmacy/order-items/medications/pharmacy-treatments/pharmacy-treatment-details'
import PharmacyMedicationDetails from 'pages/providers/pharmacy/order-items/medications/pharmacy-medications/pharmacy-medication-details'
import OrderDetails from 'components/orders/order-details'
const MyClinics = lazy(() => import('pages/providers/clinics/MyClinics'))
const ClinicReviews = lazy(() => import('pages/providers/clinics/ClinicReviews'))
const PhiControl = lazy(() => import('pages/profile/phi'))
const DiscountSearchResult = lazy(() => import('pages/easy-med/discount'))
const OrderItems = lazy(() => import('pages/providers/pharmacy/order-items'))
const OrderItemType = lazy(() => import('pages/providers/pharmacy/order-items/order-item-type'))
const OtherClinics = lazy(() => import('pages/providers/clinics/OtherClinics'))
const CartDetails = lazy(() => import('components/orders/cart/cart-details'))

const DeleteAccount = lazy(() => import('pages/profile/delete-account'))
const TrackOrder = lazy(() => import('pages/orders/track-order'))
const ReceiptDetails = lazy(
  () => import('pages/providers/clinics/clinc-detail/clinical-payments/receipts/receipt-details')
)
const Invoices = lazy(
  () => import('pages/providers/clinics/clinc-detail/clinical-payments/invoices')
)
const Receipts = lazy(
  () => import('pages/providers/clinics/clinc-detail/clinical-payments/receipts')
)
const ClinicAdmissions = lazy(
  () => import('pages/providers/clinics/clinc-detail/clinic-admissions')
)
const RequestList = lazy(
  () =>
    import(
      'pages/providers/clinics/clinc-detail/clinic-appointments/clinc-request-appointment/request-list'
    )
)
const ClinicScheduledAppointment = lazy(
  () =>
    import('pages/providers/clinics/clinc-detail/clinic-appointments/clinic-scheduled-appointment')
)
const ClinicHistory = lazy(
  () => import('pages/providers/clinics/clinc-detail/clinic-appointments/clinic-history')
)

const RefillHistory = lazy(
  () =>
    import(
      'pages/providers/clinics/clinc-detail/clinic-treatments/treatment-details/treatment-medications/refill-history'
    )
)

const OtherClinicProfile = lazy(() => import('pages/providers/clinics/ClinicProfile'))

const TreatmentDetail = lazy(
  () => import('pages/providers/clinics/clinc-detail/clinic-treatments/treatment-details')
)
const ClinicRequestAppointment = lazy(
  () => import('pages/providers/clinics/clinc-detail/clinic-appointments/clinc-request-appointment')
)

const TreatmentAppointments = lazy(
  () =>
    import(
      'pages/providers/clinics/clinc-detail/clinic-treatments/treatment-details/treatment-appoinments'
    )
)
const TreatmentPrescriptions = lazy(
  () =>
    import(
      'pages/providers/clinics/clinc-detail/clinic-treatments/treatment-details/treatment-prescriptions'
    )
)
const TreatmentMedications = lazy(
  () =>
    import(
      'pages/providers/clinics/clinc-detail/clinic-treatments/treatment-details/treatment-medications'
    )
)
const Wallet = lazy(() => import('pages/wallet'))
const RequestNewAppointment = lazy(
  () =>
    import(
      'pages/providers/clinics/clinc-detail/clinic-appointments/clinic-history/request-new-appointment'
    )
)
const AdmissionDetail = lazy(
  () => import('pages/providers/clinics/clinc-detail/clinic-admissions/admission-detail')
)

const ClinicPayments = lazy(() => import('pages/providers/clinics/clinc-detail/clinical-payments'))
const InvoiceDetails = lazy(
  () => import('pages/providers/clinics/clinc-detail/clinical-payments/invoices/invoice-details')
)
// const OrderDetails = lazy(() => import('pages/orders/order-details'))

const ClinicTreatments = lazy(
  () => import('pages/providers/clinics/clinc-detail/clinic-treatments')
)

const Pharmacies = lazy(() => import('pages/providers/pharmacy'))

// const CompletedOrders = lazy(() => import('pages/orders/completed-orders'))

const Clinics = lazy(() => import('pages/providers/clinics'))
const ClinicDetail = lazy(() => import('pages/providers/clinics/clinc-detail'))
const ClinicAppointments = lazy(
  () => import('pages/providers/clinics/clinc-detail/clinic-appointments')
)
const EditAppointment = lazy(
  () => import('pages/providers/clinics/clinc-detail/clinic-appointments/edit-appointment')
)
const AppointmentDetail = lazy(
  () =>
    import(
      'pages/providers/clinics/clinc-detail/clinic-appointments/clinic-history/appointment-details/AppointmentDetails'
    )
)
const ForgotPassword = lazy(() => import('pages/forgot-password'))
const EasyMed = lazy(() => import('pages/easy-med'))
const Home = lazy(() => import('pages/home'))
const Main = lazy(() => import('layout/main'))
const OnboardingLayout = lazy(() => import('layout/onboarding'))
const Register = lazy(() => import('pages/register'))
const Providers = lazy(() => import('pages/providers'))
const MyProviders = lazy(() => import('pages/providers/MyProviders'))
const ViewStatus = lazy(() => import('pages/orders/ViewStatus'))
const Profile = lazy(() => import('pages/profile'))
const ShippingAddress = lazy(() => import('pages/profile/shipping-address'))
const EditProfile = lazy(() => import('pages/profile/EditProfile'))
const Orders = lazy(() => import('pages/orders'))
const Notifications = lazy(() => import('pages/notifications'))
const PrescriptionConfirmation = lazy(() => import('pages/prescription/PrescriptionConfirmation'))

function AllRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<OnboardingLayout />}>
          <Route path="/login" element={<Login />}>
            <Route path="set-new-password" element={<SetPassword />} />
          </Route>
          <Route path="/signup" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Route>

        <Route
          element={
            <AppProvider>
              <Main />
            </AppProvider>
          }
        >
          <Route path="/" element={<Home />} />

          <Route path="/orders" element={<Orders />}>
            <Route path="cart/:id" element={<CartDetails />} />

            <Route path="ongoing/:id" element={<OrderDetails />} />
            <Route path="completed/:id" element={<OrderDetails />} />
            <Route path="view-status" element={<ViewStatus />} />
          </Route>
          <Route path="track-order">
            <Route path=":id" element={<TrackOrder />} />
          </Route>
          <Route path="/easy-med" element={<EasyMed />}>
            <Route path="cart" element={<Cart />}>
              <Route path=":id" element={<CartDetails />} />
            </Route>
            <Route path="ongoing" element={<OrdersList isCompleted={false} />}>
              <Route path=":id" element={<OrderDetails />} />
            </Route>
            <Route path="completed" element={<OrdersList isCompleted />}>
              <Route path=":id" element={<OrderDetails />} />
            </Route>
          </Route>
          <Route path="/discount-results" element={<DiscountSearchResult />} />

          <Route path="/providers" element={<Providers />}>
            <Route path="clinics" element={<Clinics />}>
              <Route path="others" element={<OtherClinics />}>
                <Route path=":id/profile" element={<OtherClinicProfile />}>
                  <Route path="appointments" element={<ClinicAppointments />}>
                    <Route path="request-list" element={<RequestList />}>
                      <Route path="edit">
                        <Route path=":requestedAppointmentId" element={<EditAppointment />} />
                      </Route>
                    </Route>
                    <Route path="scheduled" element={<ClinicScheduledAppointment />} />
                    <Route path="history" element={<ClinicHistory />}>
                      <Route path=":appointmentId" element={<AppointmentDetail />} />
                      <Route path="request" element={<RequestNewAppointment />}>
                        <Route path=":requestedAppointmentId" element={<RequestNewAppointment />} />
                      </Route>
                    </Route>
                    <Route path="request" element={<ClinicRequestAppointment />} />

                    <Route path=":appointmentId" element={<AppointmentDetail />} />
                  </Route>
                  <Route path="reviews" element={<ClinicReviews />} />
                </Route>
              </Route>
              <Route path="mine" element={<MyClinics />}>
                <Route path=":id/appointments" element={<ClinicAppointments />}>
                  <Route path="request-list" element={<RequestList />}>
                    <Route path="edit">
                      <Route path=":requestedAppointmentId" element={<EditAppointment />} />
                    </Route>
                  </Route>
                  <Route path="scheduled" element={<ClinicScheduledAppointment />} />
                  <Route path="history" element={<ClinicHistory />}>
                    <Route path=":appointmentId" element={<AppointmentDetail />} />
                    <Route path="request" element={<RequestNewAppointment />}>
                      <Route path=":requestedAppointmentId" element={<RequestNewAppointment />} />
                    </Route>
                  </Route>
                  <Route path="request" element={<ClinicRequestAppointment />} />

                  <Route path=":appointmentId" element={<AppointmentDetail />} />
                </Route>
                <Route path=":id/profile/reviews" element={<ClinicReviews />} />
              </Route>
              <Route path=":id" element={<ClinicDetail />}>
                <Route path="appointments" element={<ClinicAppointments />}>
                  <Route path="request-list" element={<RequestList />}>
                    <Route path="edit">
                      <Route path=":requestedAppointmentId" element={<EditAppointment />} />
                    </Route>
                  </Route>
                  <Route path="scheduled" element={<ClinicScheduledAppointment />} />
                  <Route path="history" element={<ClinicHistory />}>
                    <Route path=":appointmentId" element={<AppointmentDetail />} />
                    <Route path="request" element={<RequestNewAppointment />}>
                      <Route path=":requestedAppointmentId" element={<RequestNewAppointment />} />
                    </Route>
                  </Route>
                  <Route path="request" element={<ClinicRequestAppointment />} />

                  <Route path=":appointmentId" element={<AppointmentDetail />} />
                </Route>
                <Route path="admissions" element={<ClinicAdmissions />}>
                  <Route path=":admissionId" element={<AdmissionDetail />} />
                </Route>
                <Route path="payments" element={<ClinicPayments />}>
                  <Route path="invoice" element={<Invoices />}>
                    <Route path=":invoiceId" element={<InvoiceDetails />} />
                  </Route>
                  <Route path="receipt" element={<Receipts />}>
                    <Route path=":receiptId" element={<ReceiptDetails />} />
                  </Route>
                </Route>
                <Route path="treatments" element={<ClinicTreatments />}>
                  <Route path=":treatmentId" element={<TreatmentDetail />}>
                    <Route path="appointment" element={<TreatmentAppointments />} />
                    <Route path="prescription" element={<TreatmentPrescriptions />} />
                    <Route path="medication" element={<TreatmentMedications />}>
                      <Route path=":medicationId" element={<MedicationDetails />} />
                      <Route path=":medicationId/refill-history" element={<RefillHistory />} />
                    </Route>
                  </Route>
                </Route>
              </Route>
            </Route>

            <Route path="pharmacies" element={<Pharmacies />}>
              {/* <Route path="list" element={<Pharmacies />}> */}
              <Route path=":id">
                <Route path="medications" element={<Medications />}>
                  <Route path="treatments" element={<PharmacyTreatments />}>
                    <Route path=":treatmentId" element={<PharmacyTreatmentDetails />} />
                  </Route>
                  <Route path="medications" element={<PharmacyMedications />}>
                    <Route path=":medicationId" element={<PharmacyMedicationDetails />} />
                  </Route>
                </Route>
                <Route path="order-items" element={<OrderItems />}>
                  <Route path=":item-type" element={<OrderItemType />} />
                </Route>
                <Route path="pending-orders" element={<Orders />}>
                  <Route path="cart/:id" element={<CartDetails />} />

                  <Route path="ongoing/:id" element={<OrderDetails />} />
                  <Route path="completed/:id" element={<OrderDetails />} />
                </Route>
              </Route>
              {/* </Route> */}

              <Route path="cart" element={<Cart />}>
                <Route path=":id" element={<CartDetails />} />
              </Route>

              <Route path="orders" element={<Orders />}>
                <Route path="cart/:id" element={<CartDetails />} />

                <Route path="ongoing/:id" element={<OrderDetails />} />
                <Route path="completed/:id" element={<OrderDetails />} />
                <Route path="view-status" element={<ViewStatus />} />
              </Route>
            </Route>

            <Route path="my-providers" element={<MyProviders />} />
          </Route>
          <Route path="/profile" element={<Profile />}>
            <Route path="shipping-address" element={<ShippingAddress />} />
            <Route path="phi" element={<PhiControl />} />
            <Route path="edit" element={<EditProfile />} />
            <Route path="delete" element={<DeleteAccount />} />
          </Route>

          <Route path="/notifications" element={<Notifications />} />
          <Route path="/wallet" element={<Wallet />} />
        </Route>

        <Route path="*" element={<NotFound />} />
        <Route path="confirm-request" element={<PrescriptionConfirmation />} />
      </Routes>
    </BrowserRouter>
  )
}
export default AllRoutes
